import { computed, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getFaqCategories } from "@/server/api/faq-categories.get";
import { getFaq } from "@/server/api/get-faq.get";
import { FaqCategory, FaqItem } from "@/models/FAQ";

export function useFAQ() {
  const store = useStore();
  const { t } = useI18n();

  const categories = ref<FaqCategory[]>([]);
  const faqList = ref<FaqItem[]>([]);
  const activeCategory = ref<string | null>(null);
  const openItems = reactive<Record<string, boolean>>({});

  const loadData = async () => {
    try {
      const catsResponse = await getFaqCategories();
      categories.value = (catsResponse.data.data as FaqCategory[])
        .filter((cat: FaqCategory) => cat.publish === 1)
        .sort(
          (a: FaqCategory, b: FaqCategory) =>
            parseInt(a.priority) - parseInt(b.priority)
        );

      const faqResponse = await getFaq();
      faqList.value = (faqResponse.data.data as FaqItem[])
        .filter((faq: FaqItem) => faq.publish === 1)
        .sort(
          (a: FaqItem, b: FaqItem) =>
            parseInt(a.priority) - parseInt(b.priority)
        );

      if (categories.value.length > 0) {
        activeCategory.value = categories.value[0].uuid;
      }
    } catch (error) {
      console.error(t("faq.loadError"), error);
    }
  };

  const toggleItem = (uuid: string) => {
    openItems[uuid] = !openItems[uuid];
  };

  const filteredFaq = computed(() => {
    if (!activeCategory.value) return [];
    return faqList.value.filter(
      (item) => item.category === activeCategory.value
    );
  });

  const slideClasses = (uuid: string) => {
    return [activeCategory.value === uuid ? "active" : ""];
  };

  onMounted(() => {
    loadData();
  });

  return {
    activeCategory,
    categories,
    filteredFaq,
    openItems,
    slideClasses,
    toggleItem,
  };
}
